"use strict";

const FacilityFactSheetNewController = function () {
  const routeName = "facility-fact-sheet";

  const facilityFactSheetRoute = {
    as: routeName,
    handler: function ({ data, hashString }) {
      open(data.id, { highlightId: hashString });
    },
  };

  const facilityFactSheetHighlightRoute = {
    as: `${routeName}-highlight`,
    handler: facilityFactSheetRoute.handler,
  };

  var getConfig = function () {
    const IndcomIcon = require("./indcomIcon");
    const SortUtilities = require("../general/sortUtilities");
    const alphaSorter = SortUtilities.alphaSorter;
    const numberSorter = SortUtilities.numberSorter;

    return {
      template: "factSheet/indcom/facilityFactSheet.njk",
      polygonColumnName: "projectAreaGeom",
      pointColumnName: "geom",
      iconFunction: IndcomIcon.getFacilityIconClass,
      closeUrl: "/ram/indcom/indcom-facilities",
      goToMapFunction: () => Analytics.sendDataListEvent("address_to_map"),
      getDataFunction: getData,
      prepareDataFunction: prepareData,
      onCloseFunction: onClose,
      afterOpenFunction: afterOpen,
      apiAssetName: "facility",
      dataSorting: {
        history: { key: "date", reversed: true },
        linkedAssets: { key: "type" },
      },
      tableTemplates: {
        history: "factSheet/indcom/facilityHistoryRows.njk",
        linkedAssets: "factSheet/indcom/facilityAssetRows.njk",
      },
      sortersDict: {
        displayType: alphaSorter,
        assetId: alphaSorter,
        type: alphaSorter,
        date: alphaSorter,
        lastResultDate: alphaSorter,
        installDate: alphaSorter,
        result: alphaSorter,
        displayResult: alphaSorter,
        lastResult: alphaSorter,
        treatmentCapacity: numberSorter,
        drainageArea: numberSorter,
        imperviousAreaAcres: numberSorter,
        openFindingsCount: numberSorter,
        details: alphaSorter,
      },
    };
  };

  var getData = async function (id) {
    try {
      return await ApiCalls.getFacilityForFactSheet(id);
    } catch (e) {
      ApiError.assertIs(e);
      if (e.status === 404) {
        return e;
      }
    }

    return await ResourceController.get("indcomFacilities").getById(id);
  };

  var prepareData = function (data) {
    data.readOnlyTopLevel = Session.isRegulator();
    FactSheetNew.addDisplayDates(data.history);
    data.siteCharacteristicsSettings = ToolSettings.getSetting("lid", "siteCharacteristics");
    data.dataView = Tree.get("dataView");
    data.phaseColor = data.facilityPhase
      ? MapStyles.getHexColor(IndcomFacilityPopup.getPhaseColor(data.facilityPhase))
      : "#ffffff";
    data.phaseTextColor = Misc.isDarkColor(data.phaseColor) ? "#fff" : "#000";

    if (data.pollutantsGenerated?.length) {
      const pollutantsGeneratedOptions = ToolSettings.getDomainOptions("facility_pollutant");
      data.displayPollutantsGenerated = data.pollutantsGenerated.map((pollutant) =>
        Misc.getOptionNameByValue(pollutantsGeneratedOptions, pollutant),
      );
    } else {
      data.displayPollutantsGenerated = [];
    }
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  var afterOpen = function () {
    _loadListeners();
    _handleSectionDisplay();
    // @TODO: Set up indcom facility events
  };

  var _unloadListeners = function () {
    $("#fact-sheet-container")
      .off("click", ".edit-description", _clickEditDescription)
      .off("click", "#edit-permit-info", _clickEditPermitInfo)
      .off("click", "#add-file, .edit-file", _clickAddFile)
      .off("click", ".download-file", _downloadFile)
      .off("click", "#add-contact, .edit-contact", _clickAddContact);
    UnsubmitHistoryRecord.unloadDomListeners();
    SignedReport.unloadListeners($("#fact-sheet-container"));
  };

  var _loadListeners = function () {
    _unloadListeners();
    $("#fact-sheet-container")
      .on("click", ".edit-description", _clickEditDescription)
      .on("click", "#edit-permit-info", _clickEditPermitInfo)
      .on("click", "#add-file, .edit-file", _clickAddFile)
      .on("click", ".download-file", _downloadFile)
      .on("click", "#add-contact, .edit-contact", _clickAddContact);

    UnsubmitHistoryRecord.loadDomListeners({
      recordType: "inspection",
      recordName: FactSheetNew.getData().facilityIdentifier,
      apiCall: (id) =>
        ApiCalls.unsubmitFacilityInspection(id).then(() =>
          IndcomFacilityGeoServerLayer.invalidateLayerData(),
        ),
    });
    SignedReport.loadListeners($("#fact-sheet-container"));
  };

  var _openModalToPage = function (page) {
    IndcomInventoryModalController.invokeIndcomInventoryModal(FactSheetNew.getId(), {}, page);
  };

  var onClose = function () {
    _unloadListeners();
  };

  var _clickEditDescription = function () {
    _openModalToPage("indcom-general-info");
  };

  var _clickEditPermitInfo = function () {
    _openModalToPage("indcom-general-info");
  };

  var _clickAddFile = function () {
    _openModalToPage("facility-files");
  };

  var _clickAddContact = function () {
    _openModalToPage("contacts");
  };

  var _downloadFile = function (e) {
    const permitPlanId = $(e.currentTarget).parents(`[data-category=permit]`).data("id-permit");
    ApiCalls.downloadFacilityFile(permitPlanId);
  };

  var _handleSectionDisplay = function () {
    const $factSheetContainer = $("#fact-sheet-container");
    $factSheetContainer
      .find("#permit-info-section")
      .find(".fact-group")
      .each(function () {
        if ($(this).find(".fact-item.hide").length === $(this).find(".fact-item").length) {
          $(this).addClass("hide");
        }
      });
  };

  return {
    routeName,
    facilityFactSheetRoute,
    facilityFactSheetHighlightRoute,
    open,
    getConfig,
  };
};

module.exports = FacilityFactSheetNewController();

const ApiCalls = require("../apiCalls");
const ApiError = require("../errors/apiError");
const ResourceController = require("../offline/resourceController");
const FactSheetNew = require("../general/factSheetNew");
const Analytics = require("../general/analytics");
const Session = require("../login/session");
const ToolSettings = require("../settings/toolSettings");
const Tree = require("../tree");
const IndcomFacilityGeoServerLayer = require("./indcomFacilityGeoServerLayer");
const IndcomInventoryModalController = require("./indcomInventoryModalController");
const IndcomFacilityPopup = require("./indcomFacilityPopup");
const Misc = require("../misc");
const MapStyles = require("../mapFunctions/mapStyles");
const UnsubmitHistoryRecord = require("../general/unsubmitHistoryRecord");
const SignedReport = require("../inspection/signedReport");
